import { useMutation } from 'react-query';
import { updateDemandActive } from 'src/services/api/demands';

function useUpdateDemandActive() {
  return useMutation(({ demand, data }) => updateDemandActive(demand, data));
}

export default useUpdateDemandActive;
